import type { Component } from 'vue'
import { Route } from 'lucide-vue-next'

export interface OrgDashboardTabItem {
  icon: string | Component
  labelKey: string
  value: string
}

export const ORG_DASHBOARD_TABS: readonly OrgDashboardTabItem[] = [
  { value: 'overview', labelKey: 'org.orgPage.tabs.overview', icon: 'solar:chart-2-bold-duotone' },
  { value: 'dedicated', labelKey: 'org.orgPage.tabs.dedicated', icon: Route },
  { value: 'settings', labelKey: 'org.orgPage.tabs.settings', icon: 'mdi:cog-outline' },
  { value: 'audit', labelKey: 'org.orgPage.tabs.audit', icon: 'mdi:clipboard-text-clock-outline' },
  { value: 'finance', labelKey: 'org.orgPage.tabs.finance', icon: 'mdi:cash-multiple' },
] as const

export const ORG_DASHBOARD_DEFAULT_TAB = 'overview'

/** `members` was the old name of the overview tab; keep old links working. */
export function normalizeOrgDashboardTab(raw: unknown) {
  const tab = String(raw || '').trim()
  if (!tab || tab === 'members') return ORG_DASHBOARD_DEFAULT_TAB
  return ORG_DASHBOARD_TABS.some(item => item.value === tab) ? tab : ORG_DASHBOARD_DEFAULT_TAB
}

/**
 * The tabs live in the site header, but only the org dashboard page knows whether
 * the org exists and whether the visitor may manage it, so the page publishes that
 * into shared state and the header reads it.
 */
export function useOrgDashboardTabsVisible() {
  return useState<boolean>('org-dashboard-tabs-visible', () => false)
}
